export const CART_ITEM = "CART_ITEM";